<template>
  <workspace-panel :win="win" @reload="reloadPage">
    <template #title>Apertura y Cierre de mes</template>
    <template>
      <!-- tabs -->
      <v-tabs v-model="tab" dark background-color="primary" icons-and-text>
        <v-tabs-slider color="red"></v-tabs-slider>
        <v-tab href="#open-month">
          Apertura de operaciones de mes
          <v-icon>mdi-calendar-lock-open</v-icon>
        </v-tab>
        <v-tab href="#close-month">
          Cierre de operaciones de mes
          <v-icon>mdi-calendar-lock</v-icon>
        </v-tab>
        <v-tab href="#accounting-periods">
          Períodos contables
          <v-icon>mdi-calendar-multiple</v-icon>
        </v-tab>
        <v-tab v-if="canViewPurchasesExpensesPeriods" href="#purchases-expenses-periods">
          Períodos de Compras y Gastos
          <v-icon>mdi-calendar-clock</v-icon>
        </v-tab>
      </v-tabs>

      <!-- tabs contents -->
      <v-tabs-items v-model="tab">
        <v-tab-item value="open-month">
          <v-card class="pa-1" flat>
            <accounting-open-month :win="win"></accounting-open-month>
          </v-card>
        </v-tab-item>
        <v-tab-item value="close-month">
          <v-card class="pa-1" flat>
            <accounting-close-month :win="win"></accounting-close-month>
          </v-card>
        </v-tab-item>
        <v-tab-item value="accounting-periods">
          <v-card class="pa-1" flat>
            <accounting-periods :win="win" :key="key"></accounting-periods>
          </v-card>
        </v-tab-item>
        <v-tab-item v-if="canViewPurchasesExpensesPeriods" value="purchases-expenses-periods">
          <v-card class="pa-1" flat>
            <purchases-expenses-periods :win="win" :key="key"></purchases-expenses-periods>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </template>
  </workspace-panel>
</template>

<script>
import AccountingCloseMonth from "../partial/AccountingCloseMonth.vue";
import AccountingOpenMonth from "../partial/AccountingOpenMonth.vue";
import AccountingPeriods from "../partial/AccountingPeriods.vue";
import PurchasesExpensesPeriods from "../partial/PurchasesExpensesPeriods.vue";
import { hasRoleByName } from "../../../helpers/permissions";

export default {
  name: "OpenCloseMonthPage",
  props: ["win"],
  components: {
    AccountingOpenMonth,
    AccountingCloseMonth,
    AccountingPeriods,
    PurchasesExpensesPeriods,
  },
  data: () => ({
    tab: "open-month",
    key: 0,
  }),
  computed: {
    canViewPurchasesExpensesPeriods() {
      const roles = (this.$store.state.rolesUser && this.$store.state.rolesUser.roles) || [];
      return hasRoleByName(roles, [
        'admin',
        'root',
        'Administrador del sistema',
        'Administrador de negocio',
        'AperturaCierreComprasGastos'
      ]);
    }
  },
  watch: {
    canViewPurchasesExpensesPeriods(canView) {
      if (!canView && this.tab === "purchases-expenses-periods") {
        this.tab = "open-month";
      }
    }
  },
  methods: {
    reloadPage() {
      this.key++;
      setTimeout(() => {
          window.scrollTo(0, this.$store.getters.getScrollTop)
          //alert(this.$store.getters.getScrollTop)
      },300);
    },
  },
};
</script>
